import React from 'react';
import CloudflareCaptcha from './cloudflare-captcha';
import GoogleCaptcha from './google-captcha';
import TencentCaptcha from './tencent-captcha';
export const CAPTCHA_PROVIDERS = {
  GOOGLE: 'google',
  CLOUDFLARE: 'cloudflare',
  TENCENT: 'tencent',
};
export default function CaptchaProvider({
  provider,
  siteKey,
  onVerify,
}) {
  const newSiteKey = siteKey || '';
  const newProvider = provider || 'google';

  if (!newProvider) return null;

  if (newProvider === CAPTCHA_PROVIDERS.GOOGLE) {
    return <GoogleCaptcha siteKey={newSiteKey} onVerify={onVerify} />;
  }

  if (newProvider === CAPTCHA_PROVIDERS.CLOUDFLARE) {
    return <CloudflareCaptcha siteKey={newSiteKey} onVerify={onVerify} />;
  }

  if (newProvider === CAPTCHA_PROVIDERS.TENCENT) {
    return <TencentCaptcha siteKey={newSiteKey} onVerify={onVerify} />;
  }
  return null;
}
